import * as React from 'react';
import { Dispatch } from 'redux';
import { EditParticipantRequest } from 'stageclip-common';

import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class EditEventParticipantRequest extends BaseApiPatchRequest<
  EditParticipantRequest,
  EntityNormalizers.NormalizedSingleEntity<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(participantId: string, formData: EditParticipantRequest, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/participants/${participantId}`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipant;
  }
}
